import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const SuccessIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="success" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="Oval-Copy" fill="#6EEDB8" cx="12" cy="12" r="10"></circle>
                <polygon
                    id="Path-Copy"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                    points="10.0441301 11.7180346 9 12.6956088 11.3756773 15 15 10.898503 13.8803785 10 11.2923338 12.9287839"
                ></polygon>
            </g>
        </SvgIcon>
    );
};
